import {Link as GatsbyLink, navigate} from 'gatsby'
import * as React from 'react'

const Link = ({id, link, children, className, onClick, activeClassName, obfuscate}) => {
  if (!link || !children) return null

  if (link.linktype === 'story') {
    const full_slug = link.story ? link.story.full_slug : link.cached_url

    let href = full_slug ? `/${full_slug.replace('index', '')}` : ''

    if (link.anchor) {
      href += '#' + link.anchor
    }

    if (obfuscate) {
      return (
        <span
          role='link'
          tabIndex={0}
          id={id || undefined}
          className={className}
          onClick={(e) => {
            e.preventDefault()
            if (onClick) onClick()
            if (href) navigate(href)
          }}
          style={{cursor: 'pointer'}}
        >
          {children}
        </span>
      )
    }

    return (
      <GatsbyLink
        id={id || undefined}
        to={href}
        activeClassName={activeClassName}
        className={className}
        onClick={onClick}
      >
        {children}
      </GatsbyLink>
    )
  } else {
    if (obfuscate) {
      return (
        <span
          role='link'
          tabIndex={0}
          className={className}
          id={id || undefined}
          onClick={(e) => {
            e.preventDefault()
            if (link.url) window.open(link.url, link.target || '_self', 'noopener,noreferrer')
          }}
          style={{cursor: 'pointer'}}
        >
          {children}
        </span>
      )
    }

    return (
      <a
        href={link.href ? link.href : link.url ? link.url : ''}
        className={className}
        id={id || undefined}
        target={link.target}
        rel={link.target === '_blank' ? 'noopener noreferrer' : undefined}
      >
        {children}
      </a>
    )
  }
}

export default Link
